(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-cards"] && !Shopify.designMode) return;
  try {
    

    $(document).ready(function () {
      'use strict';

      $('shopify:section:load').ready(function(){

        $('.fg-card-collection-icon').mouseenter( function(e){
          var $svg = $(this).find('svg').data('name');

          if ($svg === 'column-kinetic' || $svg === 'table-kinetic') {
            var tl = anime.timeline({
              duration: 250,
              easing: 'easeOutExpo'
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-rod-1, ' + '#' + $svg + ' .js-rod-2',
              translateY: -8
            })
            .add({
              targets: '#' + $svg + ' .js-rod-2',
              translateY: -20
            });
          }
          else if ($svg === 'switch-kinetic') {
            anime({
              duration: 500,
              easing: 'easeOutExpo',
              targets: '#' + $svg + ' .js-rod',
              transformOrigin: ("13px 55px 0"),
              rotate: '16deg'
            });
          }
          else if ($svg === 'robotic-kinetic') {
            var tl = anime.timeline({
              duration: 250,
              easing: 'easeOutExpo'
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-l-arm',
              rotate: '180deg'
            })
            .add({
              targets: '#' + $svg + ' .js-r-arm',
              rotate: '-180deg'
            })
            .add({
              targets: '#' + $svg + ' .js-blink',
              duration: 250,
              opacity: 0
            })
            .add({
              targets: '#' + $svg + ' .js-blink',
              duration: 250,
              opacity: 1
            });
          }
          else if ($svg === 'motor-kinetic') {
            var tl = anime.timeline({
              easing: 'easeOutExpo',
              loop: 2
            });
            tl
            .add({
              duration: 20,
              targets: '#' + $svg + ' .js-rod',
              rotate: '180deg'
            })
            .add({
              duration: 250,
              targets: '#' + $svg + ' .js-rod',
              rotate: '180deg'
            })
            .add({
              duration: 20,
              targets: '#' + $svg + ' .js-rod',
              rotate: '0deg'
            })
            .add({
              duration: 350,
              targets: '#' + $svg + ' .js-rod',
              rotate: '0deg'
            })
            ;
          }
          else if ($svg === 'power_supply-kinetic') {
            var tl = anime.timeline({
              easing: 'easeOutExpo',
              loop: 2
            });
            tl
            .add({
              opacity: 1,
              duration: 20,
              targets: '#' + $svg + ' .js-blink',
              rotate: '180deg'
            })
            .add({
              duration: 500,
              targets: '#' + $svg + ' .js-blink',
              rotate: '180deg'
            })
            .add({
              opacity: 1,
              duration: 20,
              targets: '#' + $svg + ' .js-blink',
              rotate: '0deg'
            })
            .add({
              duration: 500,
              targets: '#' + $svg + ' .js-blink',
              rotate: '0deg'
            })
            ;
          }
          else if ($svg === 'sale-kinetic') {
            anime({
              duration: 1000,
              easing: 'easeOutExpo',
              transformOrigin: ("70px 10px 0"),
              targets: '#' + $svg + ' .js-rod',
              rotate: '-45deg'
            });
          }
          else if ($svg === 'bracket-kinetic') {
            var tl = anime.timeline({
              duration: 250,
              easing: 'easeOutExpo'
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-rod-1, ' + '#' + $svg + ' .js-rod-2',
              translateY: -20,
            })
            .add({
              targets: '#' + $svg + ' .js-rod-2',
              translateX: 20
            });
          }
          else if ($svg === 'controller-kinetic' || $svg === 'relay-kinetic') {
            var tl = anime.timeline({
              duration: 250,
              easing: 'easeOutExpo'
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-wires > stroke-rod-midtone',
              opacity: 0,
            })
            .add({
              targets: '#' + $svg + ' .js-blink',
              opacity: 0,
            })
            .add({
              targets: '#' + $svg + ' .js-wires > .stroke-rod-midtone',
              strokeDashoffset: [anime.setDashoffset, 0],
              easing: 'easeInOutSine',
              opacity: 1,
              duration: 300,
              direction: 'normal'
            })
            .add({
              targets: '#' + $svg + ' .js-blink',
              duration: 500,
              opacity: 1,
              direction: 'alternate',
              loop: 4
            });
          }
          else if ($svg === 'remote-kinetic') {
            var tl = anime.timeline({
              easing: 'easeOutExpo',
              duration: 250,
              loop: 2
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-down-blink',
              opacity: 0
            })
            .add({
              targets: '#' + $svg + ' .js-up-blink',
              opacity: 0
            })
            .add({
              targets: '#' + $svg + ' .js-blink',
              opacity: 0
            })
            ;
          }
          else if($svg === 'cable-kinetic') {
            anime({
              targets: '#' + $svg + ' .js-rod',
              translateY: -20,
              delay: anime.stagger(100, {direction: 'reverse'})
            });
          }
          else if($svg === 'track-kinetic') {
            anime({
              duration: 500,
              easing: 'easeOutExpo',
              targets: '#' + $svg + ' .js-rod',
              translateY: -50
            });
          }
          else {
            anime({
              duration: 500,
              easing: 'easeOutExpo',
              targets: '#' + $svg + ' .js-rod',
              translateY: -20
            });
          }
        })
        /*
        **
        ** MouseLeave
        **
        */
        $('.fg-card-collection-icon').mouseleave(function(e){
          var $svg = $(this).find('svg').data('name');
          if ($svg === 'column-kinetic' || $svg === 'table-kinetic') {
            var tl = anime.timeline({
              duration: 250
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-rod-1, ' + '#' + $svg + ' .js-rod-2',
              translateY: 0
            })
            .add({
              targets: '#' + $svg + ' .js-rod-2',
              translateY: 0
            });
          }
          else if ($svg === 'switch-kinetic') {
            anime({
              duration: 500,
              targets: '#' + $svg + ' .js-rod',
              transformOrigin: ("13px 55px 0"),
              rotate: '0deg'
            });
          }
          else if ($svg === 'robotic-kinetic') {
            var tl = anime.timeline({
              duration: 250,
              easing: 'easeOutExpo'
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-l-arm',
              rotate: '0'
            })
            .add({
              targets: '#' + $svg + ' .js-r-arm',
              rotate: '0'
            });
          }
          else if ($svg === 'motor-kinetic') {
            anime({
              duration: 20,
              targets: '#' + $svg + ' .js-rod',
              rotate: '0deg'
            });
          }
          else if ($svg === 'power_supply-kinetic') {
            anime({
              duration: 20,
              opacity: 0,
              targets: '#' + $svg + ' .js-blink',
              rotate: '0deg'
            });
          }
          else if ($svg === 'sale-kinetic') {
            anime({
              duration: 500,
              transformOrigin: ("70px 10px 0"),
              targets: '#' + $svg + ' .js-rod',
              rotate: '0deg'
            });
          }
          else if ($svg === 'bracket-kinetic') {
            var tl = anime.timeline({
              duration: 250
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-rod-2',
              translateX: 0
            })
            .add({
              targets: '#' + $svg + ' .js-rod-1, ' + '#' + $svg + ' .js-rod-2',
              translateY: 0
            });
          }
          else if ($svg === 'controller-kinetic') {
            var tl = anime.timeline({
              duration: 250
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-wires > *',
              opacity: 1
            })
            .add({
              targets: '#' + $svg + ' .js-blink',
              opacity: 1
            });
          }
          else if ($svg === 'remote-kinetic') {
            var tl = anime.timeline({
              duration: 250
            });
            tl
            .add({
              targets: '#' + $svg + ' .js-down-blink',
              opacity: 1
            })
            .add({
              targets: '#' + $svg + ' .js-up-blink',
              opacity: 1
            })
            .add({
              targets: '#' + $svg + ' .js-blink',
              opacity: 1
            })
            ;
          }
          else if($svg === 'cable-kinetic') {
            anime({
              targets: '#' + $svg + ' .js-rod',
              translateY: 0,
              easing: 'easeOutElastic(1, 2)',
              delay: anime.stagger(100, {direction: 'reverse'})
            });
          }
          else {
            anime({
              duration: 500,
              targets: '#' + $svg + ' .js-rod',
              translateY: 0
            });
          }
        })
      });

    });


  } catch(e) { console.error(e); }
})();
})();
